import React, { useState } from 'react';
import { Box } from '@mui/material';
import { TextField, Button, Typography, Card, CardContent, InputAdornment, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authServices } from '../../services/authentication/authServices';
import { useAuth } from '../../services/authentication/authContext';
const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const navigate = useNavigate();
    const { storeTokens } = useAuth();

    const handleLogin = (e) => {
        e.preventDefault();

        const loginFormData = {
            username,
            password
        };

        authServices.postLoginData(loginFormData)
            .then((response) => {

                if (response.accessToken && response.refreshToken) {
                    const { accessToken, refreshToken } = response;

                    // Store tokens in localStorage
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', refreshToken);
                    localStorage.setItem('passwordChanged', response.passwordChanged ? "true" : "false");
                    storeTokens(accessToken, refreshToken);
                    // Success message
                    setSuccessMessage("User logged in successfully!");

                    // Clear form fields
                    setUsername('');
                    setPassword('');

                    setTimeout(() => {
                        setSuccessMessage(null);
                    }, 5000);

                    onLogin(true);
                    if (response.passwordChanged === false) {
                        navigate('/change-password', { replace: true });
                    } else {
                        navigate('/home', { replace: true });
                    }

                } else {
                    setError("Invalid login credentials.");
                }
            })
            .catch((error) => {

                if (error.response) {
                    switch (error.response.status) {
                        case 500:
                            setError("Server error. Please try again later.");
                            break;
                        case 400:
                            setError("Bad request. Please verify the entered details.");
                            break;
                        default:
                            setError("Invalid credentials. Please check your username and password.");
                            break;
                    }
                } else {
                    setError("Network error. Please check your internet connection and try again.");
                }
                setTimeout(() => {
                    setError(null);
                }, 5000);

            });
    };


    return (
        <div style={{
            display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh',
            background: 'linear-gradient(to right, #045864, #FF6B6B)', fontFamily: 'Poppins, sans-serif',
        }}>
            <Card sx={{ width: 400, padding: '1.25rem', borderRadius: '1rem', boxShadow: 3, backgroundColor: '#ffffff' }}>
                <CardContent>
                    <Typography variant="h3" align="center" gutterBottom sx={{
                        fontWeight: 700,
                        fontSize: '2.25rem',
                        color: '#045864',
                        letterSpacing: '2px',
                        animation: 'fadeIn 1s ease-out',
                    }}>
                        Workmate
                    </Typography>

                    {/* Success and Error messages */}
                    {successMessage && (
                        <Alert variant="filled" severity="success" sx={{ marginTop: 2 }}>
                            {successMessage}
                        </Alert>
                    )}
                    {error && (
                        <Alert variant="outlined" severity="error" sx={{ marginTop: 2 }}>
                            {error}
                        </Alert>
                    )}

                    {/* Login Form */}
                    <form onSubmit={handleLogin}>
                        <TextField
                            label="E-Mail"
                            variant="outlined"
                            fullWidth
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            type="email"
                            required
                            margin="normal"
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <i className="fa fa-envelope" style={{ color: '#045864' }}></i>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />

                        <TextField
                            label="Password"
                            variant="outlined"
                            fullWidth
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type="password"
                            required
                            margin="normal"
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <i className="fa fa-lock" style={{ color: '#045864' }}></i>
                                        </InputAdornment>
                                    ),
                                }
                            }}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ marginTop: 2, padding: '0.75rem', fontSize: '1rem', textTransform: 'none' }}
                        >
                            Login
                        </Button>
                    </form>

                    <Box sx={{ textAlign: 'center', marginTop: 1.5 }}>
                        <button
                            type="button"
                            onClick={() => navigate('/forgot-password')}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#045864',
                                cursor: 'pointer',
                                fontSize: '0.875rem',
                                textDecoration: 'underline',
                                padding: 0,
                                fontFamily: 'inherit',
                            }}
                        >
                            Forgot password?
                        </button>
                    </Box>

                    {/* Sign Up Link
                    <Box sx={{ textAlign: 'center', marginTop: 2 }}>
                        <Typography variant="body2">
                            Don't have an account?{' '}
                            <Button onClick={handleSignUpClick} style={{ color: '#045864' }}>
                                Sign Up
                            </Button>
                        </Typography>
                    </Box> */}
                </CardContent>
            </Card>
        </div>
    );
};

export default Login;
